module.exports = __webpack_public_path__ + "img/tarj2-7.2ed2ec9f.svg";